/* eslint-disable @typescript-eslint/ban-types */
import { PublicApplicationData } from '@flatsy/types/Applications'
import { booleanOrUndefined } from './Format/booleanOrUndefined'
import { householdNumber } from './Format/householdNumber'
import { numberOrUndefined } from './Format/numberOrUndefined'
import { stringOrUndefined } from './Format/stringOrUndefined'

export const sanitizeApplicationObject = (
  application: PublicApplicationData
): PublicApplicationData => {
  const object: PublicApplicationData = {
    ...application,
    availability_months: stringOrUndefined(application.availability_months),
    household_adults: householdNumber(application.household_adults),
    household_children: householdNumber(application.household_children),
    household_type: stringOrUndefined(application.household_type),
    booking_state: undefined,
    asset: stringOrUndefined(application.asset),
    booking_wanted_date: stringOrUndefined(application.booking_wanted_date),
    booking_wanted_time: stringOrUndefined(application.booking_wanted_time),
    buying_reason: stringOrUndefined(application.buying_reason),
    finance_origin: stringOrUndefined(application.finance_origin),
    loan_amount: stringOrUndefined(application.loan_amount),
    is_selling: booleanOrUndefined(application.is_selling),
    company_is_created: booleanOrUndefined(application.company_is_created),
    company_creation_date: stringOrUndefined(application.company_creation_date),
    company_turnover: numberOrUndefined(application.company_turnover),
    agent: undefined,
    state: undefined,
  }

  const finalObject: PublicApplicationData = {}

  if (object.availability_months) {
    finalObject.availability_months = object.availability_months
  }

  if (object.household_adults) {
    finalObject.household_adults = object.household_adults
  }

  if (object.household_children) {
    finalObject.household_children = object.household_children
  }

  if (object.household_type) {
    finalObject.household_type = object.household_type
  }

  if (object.booking_state) {
    finalObject.booking_state = object.booking_state
  }

  if (object.asset) {
    finalObject.asset = object.asset
  }

  if (object.booking_wanted_date) {
    finalObject.booking_wanted_date = object.booking_wanted_date
  }

  if (object.booking_wanted_time) {
    finalObject.booking_wanted_time = object.booking_wanted_time
  }

  if (object.buying_reason) {
    finalObject.buying_reason = object.buying_reason
  }

  if (object.finance_origin) {
    finalObject.finance_origin = object.finance_origin
  }

  if (object.loan_amount) {
    finalObject.loan_amount = object.loan_amount
  }

  if (object.is_selling) {
    finalObject.is_selling = object.is_selling
  }

  if (object.agent) {
    finalObject.agent = object.agent
  }

  if (object.state) {
    finalObject.state = object.state
  }

  if (object.company_is_created) {
    finalObject.company_is_created = object.company_is_created
  }

  if (object.company_creation_date) {
    finalObject.company_creation_date = object.company_creation_date
  }

  if (object.company_turnover) {
    finalObject.company_turnover = object.company_turnover
  }

  if (object.couple_union) {
    finalObject.couple_union = object.couple_union
  }

  if (application.lead) {
    const { first_name, last_name, phone_number, email } = application.lead
    if (first_name || last_name || phone_number || email) {
      finalObject.lead = {
        first_name: stringOrUndefined(first_name),
        last_name: stringOrUndefined(last_name),
        phone_number: stringOrUndefined(phone_number),
        email: stringOrUndefined(email),
      }
    }
  }

  return finalObject
}
